import { render, staticRenderFns } from "./Tlumaczenia.vue?vue&type=template&id=22191c7c"
import script from "./Tlumaczenia.vue?vue&type=script&lang=js"
export * from "./Tlumaczenia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports